import { gsap } from 'gsap';
import { InertiaPlugin } from 'gsap/InertiaPlugin.js';

export default class Hero {
  constructor(element) {
    this.element = element;
    this.oldX = 0;
    this.oldY = 0;
    this.deltaX = 0;
    this.deltaY = 0;

    gsap.registerPlugin(InertiaPlugin);

    this.init();
  }

  init() {
    this.initMouseMove();
    this.initImageHover();
  }

  // Suit le mouvement de la souris dans la zone principale
  initMouseMove() {
    this.element.addEventListener('mousemove', (e) => {
      this.deltaX = e.clientX - this.oldX;
      this.deltaY = e.clientY - this.oldY;

      this.oldX = e.clientX;
      this.oldY = e.clientY;
    });
  }

  // Déclenche une animation quand la souris entre sur une image
  initImageHover() {
    const imageElements = this.element.querySelectorAll('.image-hero');

    for (let i = 0; i < imageElements.length; i++) {
      const el = imageElements[i];
      el.addEventListener('mouseenter', () => this.animateImage(el));
    }
  }

  // Animation GSAP appliquée à chaque image
  animateImage(el) {
    const image = el.querySelector('img');

    const tl = gsap.timeline({
      onComplete: () => {
        tl.kill();
      },
    });

    tl.timeScale(1.2);

    tl.to(image, {
      inertia: {
        x: { velocity: this.deltaX * 5, end: 0 },
        y: { velocity: this.deltaY * 5, end: 0 },
      },
    });

    tl.fromTo(
      image,
      { rotate: 0 },
      {
        duration: 0.4,
        rotate: (Math.random() - 0.5) * 15,
        yoyo: true,
        repeat: 1,
        ease: 'power1.inOut',
      },
      '<' // The animation starts at the same time as the previous tween
    );
  }
}
